import React, { FC } from 'react';
import { FormattedMessage, MessageValue } from 'react-intl';
import { ErrorMessage as FormikErrorMessage } from 'formik';
import { createUseStyles } from 'react-jss';

export type ErrorMessageObject = { message: string; values?: { [key: string]: MessageValue | JSX.Element } };

type ErrorMessageProps = {
	name: string;
	extract?: (error: ErrorMessageObject) => { message: string };
	inForm?: boolean;
	error?: ErrorMessageObject | null;
};

const useStyles = createUseStyles({
	error: {
		color: 'red',
		textAlign: 'left',
		paddingTop: '5px',
		paddingLeft: '10px',
	},
});

export const ErrorMessage: FC<ErrorMessageProps> = ({ extract, error: _error, inForm = true, ...props }) => {
	const classes = useStyles();

	if (inForm) {
		return (
			<FormikErrorMessage {...props}>
				{(formikError: any) => {
					const error = _error || formikError;
					return (
						<FormattedMessage
							id={`form.error.${(extract ? extract(error) : error).message}`}
							values={error.values}
						>
							{message => <div className={classes.error}>{message}</div>}
						</FormattedMessage>
					);
				}}
			</FormikErrorMessage>
		);
	}

	if (!_error) {
		return null;
	}

	return (
		<div>
			<FormattedMessage id={`form.error.${(extract ? extract(_error) : _error).message}`} values={_error.values}>
				{message => <div className={classes.error}>{message}</div>}
			</FormattedMessage>
		</div>
	);
};
